import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

import { ScheduleCellStatus } from '@main-application/boards/interfaces/board.enums';
import { TimezoneHelper } from '@main-application/management/components/system-configuration/components/timezone.helper';
import { OpenApiService } from '@widgets/open-api.service';

class WidgetTurnScheduleResponce {
  unitInfo: {
    unitName: string;
    unitType: string;
    propertyName: string;
    propertyAddress: {
      propertyToAddressLinkId: number;
      id: number;
      addressType: number;
      addressTypeUrn: string;
      title: string;
      street1: string;
      street2: string;
      city: string;
      state: string;
      zip: string;
      url: string;
    };
  };
  turnInfo: {
    dateMoveIn: Date;
  };
  turnStepScheduleInfo: {
    assignee: number;
    dueDate: Date;
    dateCompleted: Date;
    name: string;
    status: ScheduleCellStatus;
  };
}

export class JwtInfo {
  tenantSubscriptionId: number;
  turnStepScheduleId: number;
  authKey: string;
  assignee: number;
  nbf: number;
  exp: number;
  iat: number;
  iss: string;
}

@Injectable({
  providedIn: 'root',
})
export class BoardBuilderService {
  constructor(protected service: OpenApiService) {}
  public markAsDone(jwtToken: string): Observable<null> {
    return this.service.post(`BB/markAsDone?jwtToken=${jwtToken}`);
  }

  public reschedule(jwtToken: string, date: Date): Observable<string> {
    const dateWithoutTimezone = TimezoneHelper.removeTimeZone(date);
    return this.service.post<string>(`BB/reschedule?jwtToken=${jwtToken}`, { newDueDate: dateWithoutTimezone });
  }

  public getTurnStepInfo(jwtToken: string): Observable<WidgetTurnScheduleResponce> {
    return this.service.get<WidgetTurnScheduleResponce>(`BB/getTurnStepInfo?jwtToken=${jwtToken}`).pipe(
      map(data => {
        data.turnInfo.dateMoveIn = TimezoneHelper.addTimeZoneAndKeepOnlyDatePart(data.turnInfo.dateMoveIn);
        data.turnStepScheduleInfo.dueDate = TimezoneHelper.addTimeZoneAndKeepOnlyDatePart(
          data.turnStepScheduleInfo.dueDate
        );
        return data;
      })
    );
  }

  public postComment(jwtToken: string, comment: string): Observable<null> {
    return this.service.post(`BB/postComment?jwtToken=${jwtToken}`, { comment });
  }
}
